import { Route } from '@angular/router';
import { SettingsPage } from './settings.page';

export const SETTINGS_ROUTES: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        component: SettingsPage,
        data: { trackingId: 'Settings' }
    },
    {
        path: 'debug',
        loadChildren: () => import('army-builder-shared/src/lib/global/debug').then((m) => m.DebugModule),
        data: { trackingId: 'Settings > Debug' }
    }
];
